import './tooltip-styles.css';
export var axisName = '_1u58xor1-3-15-1';
export var axisValue = '_1u58xor2-3-15-1';
export var duration = '_1u58xor3-3-15-1';
export var wrapper = '_1u58xor0-3-15-1';